import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

import PencilIcon from 'calcite-ui-icons-react/PencilIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import UploadIcon from 'calcite-ui-icons-react/UploadIcon';

import MapController from '../../../controllers/MapController';
import SketchController from '../../../controllers/SketchContoller';
import { RootState } from '../../../reducers/app';
import { toggleMapLoader } from '../../../reducers/mapview/actions';

import ga, { GACategories, GAActions } from '../../../utils/googleAnalytics.utils';

import './draw-tools.scss';

const DrawTools = ({ dataType }: { dataType: string }) => {
  // feature service updates
  const [featureService, setFeatureService] = useState('');
  const [featureServiceError, setFeatureServiceError] = useState(false);
  const { addToast } = useToasts();

  const addFeatureService = async (e: any) => {
    e.preventDefault()

    try {
      setFeatureServiceError(false)
      const result = await MapController.addFeatureService(featureService)
      setFeatureService('')
      addToast(result, { appearance: 'success', autoDismiss: true });
      dispatch(toggleMapLoader(false));
    } catch (error) {
      setFeatureServiceError(true)
      addToast(error as string, { appearance: 'error', autoDismiss: true });
      dispatch(toggleMapLoader(false));
    }

  }

  // LOCAL STATE

  // REDUX
  const sketchToolActive = useSelector((state: RootState) =>
    dataType === 'audit' ? state.mapview.sketchToolActive : state.mapview.contextualSketchToolActive
  );
  const auditArea = useSelector((state: RootState) => (dataType === 'audit' ? state.auditdata.auditArea.graphic : null));
  const dispatch = useDispatch();

  const uploadFile = async (file: React.ChangeEvent<HTMLInputElement>) => {
    const filename = file.target.value.toLowerCase();
    ga.event(GACategories.File, GAActions.Uploaded, filename);
    if (filename.includes('.kmz') || filename.includes('.kml')) {
      file.persist();
      const currFile = file.target && file.target.files && file.target.files[0];
      try {
        await MapController.processKML(currFile, dataType);
        dispatch(toggleMapLoader(false));
      } catch (e) {
        addToast('Error converting the KMZ', { appearance: 'error', autoDismiss: true });
        dispatch(toggleMapLoader(false));
      }
    } else {
      MapController.createShapeFileGraphic(filename, dataType)
        .then((res: string) => {
          dispatch(toggleMapLoader(false));
        })
        .catch((res: string) => {
          addToast(res, { appearance: 'error', autoDismiss: true });
          dispatch(toggleMapLoader(false));
        });
    }
  };

  return (
    <React.Fragment>
      <div className='draw-tools'>
        <button
          className={`draw-tools__polygon ${sketchToolActive ? ' selected' : ''}`}
          onClick={() =>
            dataType === 'audit'
              ? SketchController.toggleAuditSketchTool(!sketchToolActive, dataType)
              : SketchController.toggleContextualSketchTool(!sketchToolActive)
          }
          disabled={!!auditArea}
        >
          <p>{sketchToolActive ? 'Cancel Draw' : 'Draw Polygon'}</p>
          <PencilIcon />
        </button>
        <button className='draw-tools__upload'>
          <p>Upload File</p>
          <UploadIcon />
        </button>
        <form encType='multipart/form-data' method='post' id='uploadForm'>
          <input
            type='file'
            name='file'
            className='draw-tools__upload'
            onChange={(e) => uploadFile(e)}
            disabled={sketchToolActive || !!auditArea}
            id='file'
          />
          <label htmlFor='file'>
            Upload File <UploadIcon />
          </label>
          <p className={`draw-tools__upload-info ${sketchToolActive || !!auditArea ? 'disabled' : ''}`}>
            File Type: zipped .shp, kml, kmz
          </p>
        </form>
      </div>
      {dataType === 'audit' && (
        <div className='aoi__delete'>
          <button
            onClick={() => SketchController.clearArea(dataType)}
            className='aoi__delete-button'
            disabled={!auditArea}
          >
            <p>Delete</p>
            <TrashIcon />
          </button>
        </div>
      )}
      {
        dataType !== 'audit' && (
          <form className='feature-service-form'>
            <h3>Select Additional Data</h3>
            <label htmlFor='feature-service'>
              Add a Feature Service
            </label>
            <input
              autoFocus
              id='feature-service'
              placeholder='Enter Feature Service URL...'
              className={`${featureServiceError ? 'error' : ''} feature-service-input`}
              type='text'
              value={featureService}
              onChange={(e) => setFeatureService(e.target.value)}
            />
            <button
              type='submit'
              className='green-button '
              onClick={(e) => addFeatureService(e)}>
              Add Feature Service
            </button>
          </form>
        )
      }
      
    </React.Fragment>
  );
};

export default DrawTools;
